import _slicedToArray from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils/index';
import Cookies from 'js-cookie';
export default {
  components: {
    SearchForm: SearchForm,
    NoData: NoData
  },
  data: function data() {
    return {
      showLoading: false,
      searchFormData: [{
        title: '系统名称',
        key: '',
        placeholder: '请选择系统名称',
        type: 'select',
        selectData: [],
        selectedArr: '',
        value: ''
      }, {
        title: '角色名称',
        key: 'role',
        placeholder: '请输入角色名称',
        type: 'input',
        value: null,
        selectData: [],
        selectedArr: []
      }, {
        title: '角色状态',
        key: '',
        placeholder: '请选择角色状态',
        type: 'select',
        selectData: [{
          label: '有效',
          value: 'ACTIVE'
        }, {
          label: '失效',
          value: 'INACTIVE'
        }],
        selectedArr: '',
        value: ''
      }],
      btnType: 'search,reset',
      tableData: [],
      userRoleData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      tableheight: 540,
      activeName: 'independent',
      userId: ''
    };
  },
  created: function created() {
    this.userId = Cookies.get('user_id');
    this.searchForm(this.searchFormData);
    this.getSystemList();
    this.getUserRoleList();
  },
  methods: {
    getSystemList: function getSystemList() {
      var _this = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          res.result.records.forEach(function (item) {
            var selectvalue = {
              value: item.systemId,
              label: item.systemName
            };
            _this.searchFormData[0].selectData.push(selectvalue);
          });
        }
      });
    },
    getUserRoleList: function getUserRoleList() {
      var _this2 = this;
      var systemId = '';
      var roleName = '';
      this.showLoading = true;
      if (this.searchFormData[0].selectedArr) {
        systemId = this.searchFormData[0].selectedArr;
      }
      roleName = this.searchFormData[1].value || '';
      this.$API.getRequest({
        url: '/platform/user/userRole',
        data: {
          userId: this.userId,
          systemId: systemId,
          roleName: roleName
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.userRoleData = Array.isArray(res.result) && res.result;
        }
      });
    },
    searchForm: function searchForm(obj) {
      this.searchObj = obj;
      this.pageNum = 1;
      // this.pageSize = 10
      this.searchList(obj);
      this.getUserRoleList();
    },
    searchList: function searchList(obj) {
      var _this3 = this;
      var systemId = '';
      var roleName = '';
      var _obj = _slicedToArray(obj, 3),
        systemNameObj = _obj[0],
        roleNameObj = _obj[1],
        statusObj = _obj[2];
      this.showLoading = true;
      if (systemNameObj.selectedArr) {
        systemId = systemNameObj.selectedArr;
      }
      var status = statusObj.selectedArr || '';
      roleName = roleNameObj.value || '';
      this.$API.postRequest({
        url: '/platform/appliedRole/myRoleList',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          roleName: roleName,
          systemId: systemId,
          status: status
          // userId: this.userId
        }
      }).then(function (res) {
        _this3.showLoading = false;
        if (res.code === '0000000000') {
          _this3.tableData = res.result.records;
          _this3.total = res.result.total;
        }
      });
    },
    currentChange: function currentChange(page) {
      this.pageNum = page;
      this.searchList(this.searchObj);
    },
    sizeChange: function sizeChange(size) {
      this.pageSize = size;
      this.searchList(this.searchObj);
    },
    getChangeSelect: function getChangeSelect(item) {
      this.searchFormData.selectedArr = item.selectedArr;
    },
    deletePermission: function deletePermission(_ref) {
      var _this4 = this;
      var row = _ref.row;
      var appliedRoleId = row.appliedRoleId,
        userId = row.userId;
      this.$API.putRequest({
        url: "/platform/appliedRole/cancel?appliedRoleId=".concat(appliedRoleId, "&userId=").concat(userId)
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this4.$message.success('取消成功！');
          _this4.pageNum = 1;
          _this4.pageSize = 10;
          _this4.searchForm(_this4.searchFormData);
        }
      });
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    resetForm: function resetForm() {
      var _this$searchFormData = _slicedToArray(this.searchFormData, 2),
        systemName = _this$searchFormData[0],
        roleName = _this$searchFormData[1];
      systemName.selectedArr = null;
      roleName.value = '';
    },
    applyPermission: function applyPermission() {
      this.$router.push({
        path: '/system/permission/apply'
      });
    }
  }
};